import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    username,
    getAuthorizationHeader,
    URL
} from "../../constans/constants";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { obtenerDatosUsuario } from "../usuario/UsuarioService";
import { ReactComponent as CalendarIcon } from "../../assets/images/icons/calendar_16.svg";
import {
    mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
    integrarConHandleInput
} from '../../constans/form-error-utils';


const CustomDateInput = React.forwardRef(({ value, onClick, onChange, name, label }, ref) => (
    <div className="datepicker-wrapper">
        <div className="form-group-local">
            <input
                type="text"
                className="form-input"
                onClick={onClick}
                onChange={onChange}
                value={value}
                name={name}
                ref={ref}
                id={name}
                autoComplete="off"
                placeholder=""
            />
            <label htmlFor={name} className="form-label">
                {label}
            </label>
            <span className="icon-calendar-local">
                <CalendarIcon width={16} height={16} />
            </span>
        </div>

    </div>
));

class AdelantoSalarial extends React.Component {

    constructor(props) {
        super(props);

        const originalHandleInput = this.handleInput;

        this.handleInput = integrarConHandleInput(this, originalHandleInput);

        this.state = {
            cedulaIdentidad: "",
            nombre: "",
            fechaSolicitud: "",
            montoSolicitado: "",
            montoSolicitadoFormateado: "",
            observacion: "",
            showErrors: false,
            errors: {
                cedulaIdentidad: null,
                nombre: null,
                fechaSolicitud: null,
                montoSolicitado: null,
                observacion: null,
            },
            openPantallaCarga: false
        };
    }

    componentDidMount() {
        configurarLimpiezaAutomatica()
        this.fetchDatosUsuario(username());
    }

    fetchDatosUsuario = (username) => {
        obtenerDatosUsuario(username).then((resp) => {
            if (!resp.error)
                this.setState({
                    cedulaIdentidad: resp.datos.cedula,
                    nombre: resp.datos.nombres + " " + resp.datos.apellidos
                })
            else {
                this.setState((prevState) => ({
                    errors: {
                        ...prevState.errors,
                        cedulaIdentidad: "Error al recuperar datos",
                        nombre: "Error al recuperar datos",
                    },
                }));
            }
        })
    }

    validarFormulario = () => {
        let isValid = true;
        let errors = {
            cedulaIdentidad: null,
            nombre: null,
            fechaSolicitud: null,
            montoSolicitado: null,
            observacion: null,
        };

        let fecha = new Date(this.state.fechaSolicitud);

        if (this.state.montoSolicitado <= 0 || this.state.montoSolicitado === "") {
            isValid = false;
            errors.montoSolicitado = "Valor no válido"
        }
        if (isNaN(fecha.getTime())) {
            isValid = false;
            errors.fechaSolicitud = "Fecha no válida";
        }

        return { isValid, errors };
    };

    handleInputMontoSolicitado = (e) => {
        let val = e.target.value.replace(/\./g, '');
        if (!isNaN(val)) {
            const formattedValue = val.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            this.setState((prevState) => ({
                errors: {
                    ...prevState.errors,
                    montoSolicitado: null,
                },
                montoSolicitado: val,
                montoSolicitadoFormateado: formattedValue
            }));
        } else {
            this.setState((prevState) => ({
                errors: {
                    ...prevState.errors,
                    montoSolicitado: "Valor no valido"
                }
            }));
        }
    }

    handleBotonCancelar = () => {
        this.props.history.push('/tramites/generar')
    }

    handleInput = (e) => {
        let name = e.target.name;
        let val = e.target.value;
        if (name == 'montoSolicitado') {
            this.handleInputMontoSolicitado(e)
        } else {
            this.setState((prevState) => ({
                errors: {
                    ...prevState.errors,
                    [name]: null,
                },
                [name]: val,
            }));
        }
    };

    handleFechaSolicitud = (date) => {
        this.setState((prevState) => ({
            errors: {
                ...prevState.errors,
                fechaSolicitud: null,
            },
            fechaSolicitud: date,
        }));
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { isValid, errors } = this.validarFormulario();
        if (!isValid) {
            this.setState({ errors: errors, showErrors: true });
            mostrarErroresEnFormulario(errors);
        } else {
            mostrarErroresEnFormulario({});
            this.descargarRecibo();
        }
    };

    descargarRecibo = () => {
        this.setState({ openPantallaCarga: true });
        const url =
            URL + "tramite/pdf/tipoTramite/" + this.props.idFormulario;
        const bodyRequest = {
            cedulaIdentidad: this.state.cedulaIdentidad,
            nombreSolicitante: this.state.nombre,
            fechaSolicitud: this.state.fechaSolicitud,
            montoSolicitado: this.state.montoSolicitado,
            observacion: this.state.observacion,
        };
        axios
            .post(url, bodyRequest, {
                ...getAuthorizationHeader(),
                responseType: "blob",
            })
            .then((response) => {
                const file = new Blob([response.data], { type: "application/pdf" });
                const fileURL = window.URL.createObjectURL(file);
                this.setState({ openPantallaCarga: false });
                this.props.terminarCargaDatos(fileURL, bodyRequest);
            })
            .catch((error) => {
                this.setState({ openPantallaCarga: false });
                console.error("Error al descargar el recibo:", error);
            });
    };


    render() {
        return (
            <>
                <PantallaCarga open={this.state.openPantallaCarga} />
                <form onSubmit={this.handleSubmit}>

                    <div className="form-group__inline x2">

                        <div className="form-group">
                            <input type="text" name="cedulaIdentidad" disabled className="form-input" value={this.state.cedulaIdentidad} />
                            <label htmlFor="cedulaIdentidad" className="form-label"> Cedula de identidad </label>
                        </div>

                        <div className="form-group">
                            <input type="text" name="nombre" disabled className="form-input" value={this.state.nombre} />
                            <label htmlFor="nombre" className="form-label"> Solicitante </label>
                        </div>

                    </div>

                    <div className="form-group">
                        <DatePicker
                            showIcon
                            selectsStart
                            selected={this.state.fechaSolicitud}
                            onChange={this.handleFechaSolicitud}
                            name="fechaSolicitud"
                            customInput={
                                <CustomDateInput name="fechaSolicitud" label="Fecha solicitud" placeholder="" />
                            }
                            startDate={this.state.fechaDesde}
                            dateFormat="dd/MM/yyyy"
                            minDate={new Date()}
                            required
                        />

                    </div>
                    <div className="form-group">
                        <input type="number" id="montoSolicitado" name="montoSolicitado" className="form-input" placeholder="" value={this.state.montoSolicitado} onChange={this.handleInput} />
                        <label htmlFor="montoSolicitado" className="form-label"> Monto a solicitar </label>
                    </div>

                    <div className="form-group">
                        <textarea type="text" id="observacion" name="observacion" rows="5" className="form-input" placeholder="" value={this.state.observacion} onChange={this.handleInput} />
                        <label htmlFor="observacion" className="form-label"> Observaciones </label>
                    </div>

                    <div className="form-actions">
                        <button onClick={() => this.handleBotonCancelar()} className="btn-medium btn-link"> Cancelar </button>
                        <button type="submit" className="btn-medium btn-primary"> Continuar </button>
                    </div>

                </form>
            </>
        );
    }
}

export default withRouter(AdelantoSalarial)